/**
 * SaleListContainer
 * --
 */
import React from 'react';
import SaleListPresenter from './SaleListPresenter';

const SaleListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <SaleListPresenter />
    </>
  );
};

export default SaleListContainer;
